import { render, staticRenderFns } from "./EditProspect.vue?vue&type=template&id=b32b7e72&"
import script from "./EditProspect.vue?vue&type=script&lang=js&"
export * from "./EditProspect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports